module.exports = __webpack_public_path__ + "3ab218c49a234d0935dee8dcb7ebc83e.png";